var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-form",
    [
      _c(
        "el-form-item",
        { attrs: { label: "Name" } },
        [
          _c("el-input", {
            model: {
              value: _vm.user.name,
              callback: function ($$v) {
                _vm.$set(
                  _vm.user,
                  "name",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "user.name",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "Email" } },
        [
          _c("el-input", {
            model: {
              value: _vm.user.email,
              callback: function ($$v) {
                _vm.$set(
                  _vm.user,
                  "email",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "user.email",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v(" Update ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }